/** High-level entry: raw text -> fully-derived Flight. */

import { parseDjiSrt, type ParseResult } from './import/djiSrt.ts';
import { deriveChannels } from './derive/derive.ts';

export function loadFlightFromSrt(text: string, sourceName?: string): ParseResult {
  const result = parseDjiSrt(text, sourceName);
  deriveChannels(result.flight);
  return result;
}

export type { ParseResult };
